import moment from 'moment';

import {
  getTotalPrice,
  getTotalRelatedItems
} from 'utils/book-accommodation-and-activity/totalPrice';
import {
  getAddOns,
  getMandatoryFees,
  getGuests,
  getGuestsActivity,
  getSchedule,
  getStartingDate
} from 'utils/book-accommodation-and-activity/prepareBookDataMethods';

const getPreparedBookActivityData = (
  activity,
  bookActivityForm,
  deleteRelatedAccommodations,
  isWidget,
  stripeToken,
  payPalOrderId
) => {
  const bookActivity = bookActivityForm.values;
  const adminPlatform = bookActivity.platform
    ? bookActivity.platform
    : 'Admin panel';
  const platform = isWidget ? 'Widget' : adminPlatform;
  const idObj = bookActivity.id ? { id: bookActivity.id } : {};
  const paymentIdObj = bookActivity.paymentId
    ? { id: bookActivity.paymentId }
    : {};

  let paymentType = 'CASH';
  if (stripeToken) paymentType = 'STRIPE';
  if (payPalOrderId) paymentType = 'PAYPAL';

  return {
    activityBooking: {
      ...idObj,
      activityId: activity.generalForm.id,
      guestFirstName: bookActivity.firstName,
      guestLastName: bookActivity.lastName,
      guestPhoneNumber: bookActivity.phone,
      guestEmail: bookActivity.email,
      platform: platform,
      payment: {
        ...paymentIdObj,
        paymentType: paymentType,
        stripeToken: stripeToken,
        payPalOrderId: payPalOrderId,
        currency: bookActivity.currency,
        totalPrice: getTotalPrice(
          activity,
          bookActivity.dates,
          bookActivity.participants,
          bookActivity.addOns,
          null,
          bookActivity.accommodations,
          bookActivity.currency
        )
      },
      ...getStartingDate(bookActivity, bookActivity.multiDates),
      ...getSchedule(bookActivity),
      ...getAddOns(bookActivity, bookActivity.currency),
      ...getGuestsActivity(bookActivity, activity.pricesType, bookActivity.currency)
    },
    ..._getAccommodationBooking(bookActivity, isWidget),
    ..._getDeletedAccommodationBookings(deleteRelatedAccommodations)
  };
};

const _getAccommodationBooking = (bookActivity, isWidget) => {
  if (!bookActivity.accommodations.length) return {};

  const accommodations = isWidget
    ? bookActivity.accommodations.filter(item => item.isSelected)
    : bookActivity.accommodations;

  if (!accommodations.length) return {};

  const accommodation = accommodations[0];
  const idObj = accommodation.id && !isWidget ? { id: accommodation.id } : {};
  const paymentIdObj =
    accommodation.paymentId && !isWidget ? { id: accommodation.paymentId } : {};
  const accommodationId = isWidget
    ? accommodation.id
    : accommodation.accommodation;

  return {
    accommodationBooking: {
      ...idObj,
      accommodationId: accommodationId,
      platform: isWidget ? 'Widget' : 'Admin panel',
      fromDate: moment(accommodation.dates.startDate).format('YYYY-MM-DD'),
      toDate: moment(accommodation.dates.endDate).format('YYYY-MM-DD'),
      payment: {
        ...paymentIdObj,
        paymentType: 'CASH',
        currency: bookActivity.currency,
        totalPrice: getTotalRelatedItems(
          bookActivity.accommodations,
          bookActivity.currency
        )
      },
      ...getAddOns(accommodation, bookActivity.currency),
      ...getMandatoryFees(accommodation, bookActivity.currency),
      ...getGuests(
        accommodation,
        accommodation.pricesType,
        bookActivity.currency,
        true
      )
    }
  };
};

const _getDeletedAccommodationBookings = deleteRelatedAccommodations => {
  if (!deleteRelatedAccommodations || !deleteRelatedAccommodations.length) {
    return {};
  }

  return {
    deletedAccommodationBooking: deleteRelatedAccommodations
  };
};

export { getPreparedBookActivityData };
